import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { whyChoose } from "../mock";

const WhyChoose = () => {
  return (
    <section className="bg-brand-cream py-20">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src={whyChoose.image}
              alt="Fab Build Pro construction team"
              className="w-full h-[460px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 md:right-8 bg-brand-orange text-white rounded-2xl px-6 py-5 shadow-xl max-w-[220px]">
            <ShieldCheck className="w-8 h-8 mb-2" />
            <p className="font-display font-bold text-lg leading-tight">
              100% Satisfaction Guarantee
            </p>
            <p className="text-white/85 text-sm mt-1">
              We stand behind every project.
            </p>
          </div>
        </div>

        <div>
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            {whyChoose.eyebrow}
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl leading-tight">
            {whyChoose.title}
          </h2>
          <div className="w-20 h-1 bg-brand-orange rounded-full mt-4 mb-6" />

          <p className="font-display font-bold text-brand-slate text-lg mb-1">
            {whyChoose.heading}
          </p>
          <p className="text-brand-orangedark font-semibold mb-5">
            {whyChoose.lead}
          </p>

          <div className="space-y-4 text-slate-600 leading-relaxed">
            {whyChoose.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-8 bg-brand-navy hover:bg-brand-slate text-white font-semibold px-6 py-3.5 rounded-full transition-all hover:-translate-y-0.5 shadow-md"
          >
            About Us
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
